export class TaskAttachment {
  constructor(
    public readonly id: string,
    public readonly planningItemTaskId: string,
    public readonly name: string,
    public readonly path: string,
    public readonly url: string,
    public readonly extensionType: string,
  ) {
  }

  static fromJson(json: any): TaskAttachment {
    return new TaskAttachment(
      json['id'],
      json['planning_item_task_id'],
      json['name'],
      json['path'],
      json['url'],
      json['extension_type'],
    )
  }
}